import {
    EventCardImage,
    EventCardLink,
    EventCardLinkProps,
    EventImageProps,
    hasCarouselWidget,
} from '@eventbrite/event-renderer';
import React from 'react';
import { useServerEnrolledStatsigExperiment } from '../../../context/experiments';
import { EventCardImageExperiment } from '../../../types';
import { EventCardCarousel, EventCardCarouselProps } from './components';

export type EventCardMultiImageProps = EventCardCarouselProps & {
    isLazyImage?: EventImageProps['loading'];
    linkProps: EventCardLinkProps;
};

const autoplayOptions = {
    delay: 3500,
    stopOnMouseEnter: true,
};

export function EventCardMultiImage({
    event,
    isLazyImage,
    linkProps,
    ...props
}: EventCardMultiImageProps) {
    const { variant: eventCardImageExperiment } =
        useServerEnrolledStatsigExperiment({
            name: EventCardImageExperiment.name,
            paramName: EventCardImageExperiment.paramName,
            defaultValue: EventCardImageExperiment.values.control,
        });

    if (
        eventCardImageExperiment === EventCardImageExperiment.values.multi &&
        hasCarouselWidget(event)
    ) {
        return (
            <EventCardCarousel
                event={event}
                isLazyImage={isLazyImage}
                linkProps={linkProps}
                data-testid="event-card-carousel"
                autoplayOptions={autoplayOptions}
                {...props}
            />
        );
    } else {
        return (
            <EventCardLink {...linkProps}>
                <EventCardImage
                    name={event.name}
                    loading={isLazyImage}
                    src={event.imageUrl}
                    {...props}
                />
            </EventCardLink>
        );
    }
}
